<template>
  <transition name="fade">
    <BaseCard cardClasses="mt-3" title="مدارک کسب و کار">
      <template v-slot:header>
        <div class="w-100 d-flex flex-row justify-content-between">
          <div>مدارک کسب و کار</div>
          <v-btn color="blue" dark @click="showUploadForm = !showUploadForm">
            فرم آپلود مدرک
          </v-btn>
        </div>
      </template>
      <template>
        <transition name="bounce">
          <BusinessInformationUploadDocForm
            ref="BusinessInformationUploadDocForm"
            :showUploadForm="showUploadForm"
            :merchantDocumentTypes="merchantDocumentTypes"
            @uploadDocument="uploadDocument"
          />
        </transition>

        <BaseTable
          :headers="fields"
          :items="merchantDocuments"
          class="elevation-1 uploaded-docs"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:[`item.title`]="{ item }">
            {{ getDocumentTitle(item.documentTypeId) }}
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <v-chip small :color="getMerchantStatusColor(item.status)" dark>
              <v-icon> mdi-circle-small </v-icon>
              {{ statusDisplayName(item.status) }}
            </v-chip>
          </template>
          <template v-slot:[`item.expirationDateUtc`]="{ item }">
            <span v-if="item.expirationDateUtc">
              {{ new Date(item.expirationDateUtc).toLocaleDateString('fa-IR') }}
            </span>
            <span v-else>--</span>
          </template>
          <template v-slot:[`item.file`]="{ item }">
            <img class="thumbnail" :src="item.file.fileUrl" />
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              small
              icon
              title="مشاهده"
              color="primary"
              link
              :href="item.file.fileUrl"
              target="_blank"
            >
              <v-icon> mdi-eye </v-icon>
            </v-btn>
            <v-btn
              small
              icon
              color="error"
              class="float"
              @click="removeDocument(item)"
            >
              <v-icon> mdi-delete </v-icon>
            </v-btn>
          </template>
        </BaseTable>
      </template>
    </BaseCard>
  </transition>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
import Helper from '@/core/helpers';
const merchantRepository = () => RepoFactory.get('merchant');
const enumsRepository = () => RepoFactory.get('enums');
import { mapGetters } from 'vuex';
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';
import asyncLoadMixin from '@/core/mixins/asyncLoadMixin';
import BusinessInformationUploadDocForm from './BusinessInformationUploadDocForm';

import Swal from 'sweetalert2';
export default {
  name: 'BusinessInformationUploadDocsList',
  props: {
    freezer: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [reusableMethodsMixin, asyncLoadMixin],
  components: {
    BusinessInformationUploadDocForm,
  },
  data() {
    return {
      showUploadForm: false,
      fields: [
        {
          value: 'file',
          text: 'تصویر مدرک',
          sortable: false,
        },
        {
          value: 'title',
          text: 'عنوان مدرک',
          sortable: false,
        },
        {
          value: 'status',
          text: 'وضعیت',
          sortable: false,
        },
        {
          value: 'expirationDateUtc',
          text: 'تاریخ انقضاء',
          sortable: false,
        },
        {
          value: 'actions',
          text: 'عملیات',
          sortable: false,
        },
      ],

      documentStatusList: [],

      merchantDocumentTypes: [],
      merchantDocuments: [],
      loader: null,
      // file: {
      //   documentTypeId: null,
      //   fileId: null,
      //   description: null,
      //   expirationDateUtc: null,
      // },
    };
  },

  computed: {
    ...mapGetters([
      'merchantBaseUrl',
      'fileBaseUrl',
      'userBusinessInformation',
      'productBaseUrl',
    ]),
  },
  methods: {
    getMerchantStatusColor(status) {
      if (status == 'Accepted') {
        return 'teal lighten-2';
      }
      if (status == 'Rejected') {
        return 'red lighten-2';
      }
      if (status == 'Draft') {
        return 'blue-grey lighten-3';
      }
      if (status == 'Approved') {
        return 'blue lighten-2';
      }
      if (status == 'InProcess') {
        return 'blue lighten-2';
      }
      return '';
    },
    statusDisplayName(title) {
      const status = this.documentStatusList.find((el) => el.title == title);
      if (status) {
        return status.displayName;
      }
      return '';
    },
    getDocumentTitle(documentTypeId) {
      const item = this.merchantDocumentTypes.find(
        (el) => el.id === documentTypeId
      );
      if (item) {
        return item.value;
      }
      return '';
    },
    uploadDocument(file) {
      this.loader = this.$loading.show();
      merchantRepository()
        .addMerchantDocument(
          this.$store.getters.currentMerchant,
          file,
          this.merchantBaseUrl
        )
        .then(() => {
          Swal.fire({
            icon: 'success',
            title: 'فایل آپلود شد',
            confirmButtonText: ' بستن',
          });

          this.merchantDocuments.push({
            id: Math.floor(Math.random() * 11111111111),
            documentTypeId: file.documentTypeId,
            description: file.description,
            expirationDateUtc: file.expirationDateUtc,
            status: 'InProcess',
            expired: false,
            file: {
              fileId: file.fileId,
              fileUrl: `${this.fileBaseUrl}/api/v1/files/${file.fileId}`,
              thumbnailFileUrl: `${this.fileBaseUrl}/api/v1/files/${file.fileId}/thumbnail`,
            },
          });

          this.$refs.BusinessInformationUploadDocForm.fileId = null;
          this.$refs.BusinessInformationUploadDocForm.file.fileId = null;
          this.$refs.BusinessInformationUploadDocForm.file.description = null;
          this.$refs.BusinessInformationUploadDocForm.file.expirationDateUtc =
            null;
          this.$refs.BusinessInformationUploadDocForm.file.documentTypeId =
            null;
          this.$refs.BusinessInformationUploadDocForm.$refs.obs.reset();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => this.loader.hide());
    },

    editMerchantDocumentsListToSend() {
      return this.merchantDocuments.map((el) => {
        return {
          id: el.id,
          description: el.description,
          expirationDateUtc: el.expirationDateUtc,
          documentTypeId: el.documentTypeId,
          fileId: el.file.fileId,
        };
      });
    },
    updateMerchantDocumentsToServer(body, progress) {
      this.loader = this.$loading.show();
      merchantRepository()
        .editDocumentsByMerchant(
          this.$store.getters.currentMerchant,
          body,
          this.merchantBaseUrl
        )
        .then(() => {
          Swal.fire({
            icon: 'success',
            title: progress == 'add' ? 'فایل آپلود شد' : 'فایل حذف شد',
            confirmButtonText: ' بستن',
          });

          this.$refs.BusinessInformationUploadDocForm.fileId = null;
          this.$refs.BusinessInformationUploadDocForm.file.fileId = null;
          this.$refs.BusinessInformationUploadDocForm.file.description = null;
          this.$refs.BusinessInformationUploadDocForm.file.expirationDateUtc =
            null;
          this.$refs.BusinessInformationUploadDocForm.file.documentTypeId =
            null;
          this.$refs.BusinessInformationUploadDocForm.$refs.obs.reset();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => this.loader.hide());
    },
    removeDocument(document) {
      Swal.fire({
        html: `برای حذف فایل مطمئن هستید؟`,
        icon: 'warning',
        confirmButtonText: ' بلی',
        showCancelButton: true,
        cancelButtonText: 'خیر',
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.merchantDocuments = this.merchantDocuments.filter(
            (el) => el.id !== document.id
          );
          const body = {
            documents: this.editMerchantDocumentsListToSend(),
          };
          this.updateMerchantDocumentsToServer(body, 'remove');
        }
      });
    },
    getDocumentsByMerchant() {
      return new Promise((resolve, reject) => {
        merchantRepository()
          .getDocumentsByMerchant(
            this.$store.getters.currentMerchant,
            this.merchantBaseUrl
          )
          .then(({ data }) => {
            this.merchantDocuments = data;
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getMerchantDocumentTypes() {
      return new Promise((resolve, reject) => {
        merchantRepository()
          .getMerchantDocumentTypes(this.merchantBaseUrl)
          .then(({ data }) => {
            this.merchantDocumentTypes = data;
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getDocumentStatusList() {
      return new Promise((resolve, reject) => {
        enumsRepository()
          .getEnum('DocumentStatus', this.merchantBaseUrl)
          .then(({ data }) => {
            this.documentStatusList = data;
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getData() {
      Promise.all([
        this.getDocumentsByMerchant(),
        this.getMerchantDocumentTypes(),
        this.getDocumentStatusList(),
      ])
        .then()
        .catch((error) => {
          Helper.handleErrors(error, this);
        });
    },
  },
  watch:{
    "$store.getters.currentMerchant":function(aft, bef){
      if(aft){
       
          this.getData();
       
        }
    }
  },
  created() {
    if(this.$store.getters.currentMerchant){

        this.getData();
   
    }
  },
};
</script>

<style>
.datep label {
  margin-bottom: 0 !important;
}
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.2s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0.6);
  }
  100% {
    transform: scale(1);
  }
}
.uploaded-docs .thumbnail {
  width: 100px;
  border-radius: 5px;
  margin: 3px 0;
}
</style>
